<template>
    <Accordion @tab-open="marcarVisualizacao($event?.index)" class="identificador-accordion">
        <AccordionTab v-for="lancamento in lancamentos" v-bind:key="lancamento?.lancamentoId">
            <template #header>
                <div class="flex flex-row align-items-start">
                    <DetalheDado titulo="Lançamento">{{ lancamento?.idlan }}</DetalheDado>
                    <font-awesome-icon v-if="lancamento?.usuarioVisualizouLancamento" icon="check-double" class="text-xs ml-2 mt-2 cor-icone-visualizado" />
                </div>
            </template>
            <div class="p-flui formgrid grid">
                <div class="field col-12">
                    <hr />
                    <DetalheDado titulo="Favorecido">{{ lancamento?.favorecido }}</DetalheDado>
                    <hr />
                </div>

                <div class="field col-12">
                    <DetalheDado titulo="CPF/CNPJ">{{ $toCpfCnpj(lancamento?.cpfCnpj) }}</DetalheDado>
                    <hr />
                </div>

                <div class="field col-12">
                    <DetalheDado titulo="Valor">{{ lancamento?.valorFormatado }}</DetalheDado>
                    <hr />
                </div>

                <div class="field col-12">
                    <DetalheDado titulo="Data do Débito">{{ lancamento?.dataDebitoFormatada || 'Ainda não foi debitado' }}</DetalheDado>
                    <hr />
                </div>

                <div class="field col-12">
                    <DetalheDado titulo="Data do Pagamento">{{ lancamento?.dataPagamentoFormatada }}</DetalheDado>
                    <hr />
                </div>

                <div class="field col-12">
                    <DetalheDado titulo="Histórico">{{ lancamento?.historico }}</DetalheDado>
                    <hr />
                </div>

                <div class="field col-12">
                    <BtnVisualizarPdf :lancamento="lancamento"></BtnVisualizarPdf>
                </div>
            </div>
        </AccordionTab>
    </Accordion>
</template>

<script>
import BtnVisualizarPdf from './BtnVisualizarPdf.vue';
import DetalheDado from '../DetalheDado.vue';
import LancamentoService from './service';

export default {
    components: {
        DetalheDado,
        BtnVisualizarPdf,
    },

    props: {
        lancamentos: {
            type: Array,
        },
    },

    emits: ['visualizouLancamento'],

    methods: {
        marcarVisualizacao(lancamentoIndex) {
            if (this.lancamentos[lancamentoIndex]?.usuarioVisualizouLancamento) return;
            this.$store.dispatch('addRequest');
            LancamentoService.visualizar(this.lancamentos[lancamentoIndex]?.lancamentoId)
                .then((response) => {
                    if (response?.data) {
                        this.$emit('visualizouLancamento');
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },
    },
};
</script>

<style>
.identificador-accordion .p-accordion-tab {
    margin-bottom: 1.5rem;
}
.identificador-accordion .p-accordion-tab .p-accordion-header {
    background-color: white !important;
}

.identificador-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    background-color: white !important;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
}

.identificador-accordion .p-accordion-tab-active .p-accordion-header .p-accordion-header-link {
    border-bottom: none !important;
    padding-bottom: 0px !important;
}

.identificador-accordion .p-accordion-tab-active .p-accordion-content {
    padding-top: 0px !important;
}

.cor-icone-visualizado {
    color: #3e6ba8 !important;
}

.anexo-btn {
    width: max-content !important;
    background-color: #fff !important;
    color: #3e6ba8 !important;
    font-weight: bold;
    font-size: 1rem;
}
</style>
